import React from 'react';
import { Row, Col } from 'antd';

const IconGridView = ({ 
  items, 
  renderCard,
  gridConfig = {
    xs: 24,
    sm: 12,
    md: 8,
    lg: 6,
    xl: 4
  }
}) => {
  return (
    <Row gutter={[16, 16]}>
      {items.map((item) => (
        <Col {...gridConfig} key={item.id}>
          {renderCard(item)}
        </Col>
      ))}
    </Row>
  );
};

export default IconGridView;
